"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transferFuturesMargin = void 0;
const FutureAPI_1 = require("../../../apis/FutureAPI");
const CustomAssetsProvider_1 = require("../CustomAssetsProvider");
const operators_1 = require("rxjs/operators");
/**逐仓仓位上保证金划转 */
function transferFuturesMargin(params) {
    return (0, FutureAPI_1.futuresMarginTransfer)(Object.assign(Object.assign({}, params), { client_id: `${Date.now()}` })).pipe((0, operators_1.tap)(() => (0, CustomAssetsProvider_1.refreshAccountDetail)()));
}
exports.transferFuturesMargin = transferFuturesMargin;
